import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import ColumnContainer from "../shared/columnContainer";
import styled from "styled-components";

const Services = () => {
  const [posts, setPosts] = useState([]);
  const URL = process.env.REACT_APP_API_URL;
  const axiosPath = URL + `/posts?section=services`; // `/posts/columns/about`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(axiosPath);
        setPosts(res.data);
      } catch (err) {
        console.log("get Posts error", err);
      }
    };
    fetchData();
  }, [axiosPath]);
  

  const header = posts.filter((post) => post.header_yn === 1)[0];
 
  return (
    <Wrapper>
      <ColumnContainer
        id="header"
        name="services"
        className="column-container"
        posts={header}
        expansionLink={
          <NavLink className="serviceLink" to="/services/">
            <div className="serviceLink">
              Click here to learn more about the services we offer
            </div>
          </NavLink>
        }
      />
    </Wrapper>
  );
};
const Wrapper = styled.div`
  .column-container {
    border: none;
  }
  .serviceLink {
    font-size: 28px;
    color: var(--accentcolor4);
    text-align: center;
    margin-bottom: 20px;
  }
`;
export default Services;
